import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import TaskInfoWrapper from '../Components/TaskInfoWrapper';

import {ProtocolEditorViewMode} from '../../../constants/dataEnum';

import withIntl from '../../../lib/withIntl';

import {ProtocolEditorContext} from '../ContextProviders/ProtocolEditorContext';

import './TipsWasteBin.scss';

function TipsWasteBin({onClick, intl, task, protocolEditorMode}) {
  const {volumeDetailViewChecked} = useContext(ProtocolEditorContext) || {};
  return (
    <div className="tips-waste-bin">
      <span className="tips-waste-bin-header">{intl.formatMessage({id: 'protocolEditor.menuList.wasteBin'})}</span>
      <TaskInfoWrapper
        tasks={protocolEditorMode === ProtocolEditorViewMode.SIMPLE_TRANSFER && task ? [task] : []}
        showTaskVolume={volumeDetailViewChecked}
        showTaskNumber={false}
        fitContent
      >
        <img
          className="tips-waste-bin-img"
          alt="Waste Bin"
          src="./svg/protocol-editor/tips-waste-bin-virtual-tray.svg"
          onClick={onClick}
          role="presentation"
        />
      </TaskInfoWrapper>
    </div>
  );
}

TipsWasteBin.propTypes = {
  onClick: PropTypes.func,
  intl: PropTypes.any.isRequired,
  task: PropTypes.object,
  protocolEditorMode: PropTypes.string,
};

TipsWasteBin.defaultProps = {
  onClick: () => {
    console.log('tips waste bin is clicked');
  },
  task: undefined,
  protocolEditorMode: '',
};

export default withIntl(TipsWasteBin);
